import { Box, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import RepartionEspecesChequesRetrait from "./rep-especes-cheques-retrait";

export default function Step4(props) {
    const [repespeces, setRepEspeces] = useState(props.banqueEglise.especes??[{montant:'', count:0}])
    const [repCheque, setRepCheques] = useState(props.banqueEglise.cheques??[])

    const dispoMoney = useMemo(()=>[...new Set(props.dons?.map(don=>don.repartition.especes.map(es=>es.montant)).flat())].map(money=>{
        const count = props.dons.reduce((tt,don)=>tt+(don.repartition.especes.find(es=>es.montant===money)?.count??0),0)-(props.fedRepartition.especes.find(es=>es.montant===money)?.count??0)
        return {montant:money, count};
    }).filter(dm=>dm.count>0),[props.dons, props.fedRepartition])
    const pcDispoMoney = useMemo(()=>dispoMoney.map(money=>({...money, count:money.count-(repespeces?.find(es=>es.montant===money.montant)?.count??0)})).filter(m=>m.count>0),[dispoMoney,repespeces])
    const bqDispoMoney = useMemo(()=>dispoMoney.map(money=>({...money,count:money.count-(props.petiteCaisse?.find(es=>es.montant===money.montant)?.count??0)})).filter(m=>m.count>0),[dispoMoney,props.petiteCaisse])
    const dispoCheques = props.dons?.map(don=>don.repartition.cheques).flat().filter(cheque=> cheque&&!props.fedRepartition.cheques.includes(cheque))
    
    const ttEspeces = useMemo(()=>[...props.petiteCaisse, ...repespeces].reduce((tt,esp)=>tt+esp.montant*esp.count,0),[props.petiteCaisse, repespeces])
    const ttCheques = useMemo(()=>repCheque.reduce((tt,ch)=>tt+ch.montant,0),[repCheque])
    const total = useMemo(()=>ttEspeces+ttCheques,[ttEspeces, ttCheques])

    useEffect(()=>{
        props.setBanqueEglise(old=>{old.especes=repespeces; old.cheques=repCheque; return({...old})})
    },[repespeces,repCheque])

    useEffect(()=>{
        if (props.localVerseType.includes('petite-caisse')&&props.localVerseType.length===1) {
            props.setPetiteCaisse(dispoMoney)
        }
    },[])

    return(
        <Box>
            <Typography variant="h6" align="center">Répartition de la part locale restante</Typography>
            <Typography variant="subtitle1" align="center" color='red'>Il vous reste {props.restToRepart?.toFixed(2)}€ sur la part locale à répartir</Typography>
            {props.localVerseType.includes('petite-caisse')&&<><Typography variant="subtitle1" marginTop={2} marginBottom={1}>Petite-caisse</Typography>
            <RepartionEspecesChequesRetrait  { ...{repespeces:props.petiteCaisse, setRepEspeces:props.setPetiteCaisse, dispoMoney: pcDispoMoney, isPetiteCaisse:true}}/></>}
            {props.localVerseType.includes('banque')&&<><Typography variant="subtitle1" marginTop={2} marginBottom={1}>Banque église</Typography>
            <RepartionEspecesChequesRetrait  { ...{repespeces, setRepEspeces, dispoMoney:bqDispoMoney, repCheque,setRepCheques,dispoCheques, isBanqueEglise:true}}/></>}
            <Typography variant="h6" fontWeight='bold' align="center" marginTop={2}>Montant total réparti: {total.toFixed(2)}€</Typography>
        </Box>
    )
}